import type { ModalData } from '@white-label-types/component';
import { useEventBus } from '../use-event-bus/use-event-bus';

/**
 * Composable replacement for the `$openModal` Vue mixin.
 *
 * Emits `setModalData` on the global event emitter and returns a Promise
 * that resolves when `modalClose` fires on `window`.
 */
export function useOpenModal() {
  function openModal(modalName: string, modalData: ModalData): Promise<unknown> {
    const eventEmitter = useEventBus();

    eventEmitter.$emit('setModalData', {
      component: modalName,
      data: modalData,
    });

    return new Promise((resolve, reject) => {
      function isCustomEvent(event: Event): event is CustomEvent {
        return 'detail' in event;
      }
      const callback = (event: Event) => {
        if (isCustomEvent(event)) {
          resolve(event.detail);
        } else {
          reject(new Error('No details provided'));
        }
        window.removeEventListener('modalClose', callback);
      };
      window.addEventListener('modalClose', callback);
    });
  }

  return { openModal };
}
